/**
 * Triggers a browser download for each URL in turn, via a temporary
 * anchor click (the same "plain link, browser streams it" mechanism as a
 * single download, ADR 0008 section 5: never fetch-to-blob). Staggered
 * slightly so browsers do not treat a burst of clicks as a popup flood.
 */
export function downloadAll(urls: string[]): void {
  urls.forEach((url, index) => {
    window.setTimeout(() => {
      const link = document.createElement("a");
      link.href = url;
      link.rel = "noopener";
      link.download = "";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }, index * 200);
  });
}
